<template>
    <div>
        <section class="sell_your_device_dashboard_default text-center" style="min-height:80vh">
            <div class="container-fluid">
                <div class="service_top_section__img_section text-center" :style="{'width':'100%'}">
                    <div class="row">
                        <Sidebar></Sidebar>
                        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 mb-4 cat-block-device">
                            <div class="container-fluid">
                                <div class="container">   
                                    <div class="page">
                                        <h1 class="order-table-header-h">Your All Purchase - Paid Item</h1>
                                        <table class="layout display invoice_table responsive-table">
                                            <thead>
                                                <tr class="text-white">
                                                    <th>SL</th>
                                                    <th>Invoice ID</th>
                                                    <th>Quantity</th>
                                                    <th>Price</th>
                                                    <th>Invoice Status</th>
                                                    <th>Purchased Time</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="this.paidOrderData.length">
                                                    <tr v-for="(row, index) in this.paidOrderData" :key="index">
                                                        <td class="organisationnumber">{{ index+1 }}</td>
                                                        <td class="organisationnumber">{{ row.invoice_id }}</td>
                                                        <td class="organisationnumber">{{ row.quantity }}</td>
                                                        <td class="organisationnumber">${{ row.price }}</td>
                                                        <td class="organisationnumber">{{ row.invoice_status }}</td>
                                                        <td class="organisationname">{{ row.created_at }}</td>
                                                        <td class="actions">
                                                            <a href="javascript:void(0);" @click="viewPurchaseInvoice(row.invoice_id)" class="btnorder orange"><i class="fa fa-eye" aria-hidden="true"></i> View Order </a>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-else>
                                                    <tr>
                                                        <td class="organisationnumber" colspan="7">{{ statusMessage }}</td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>                                                                
                                </div>
                            </div>                               
                        </div>
                    </div>                  
                </div>
            </div>
        </section>       
    </div>
</template>
<style src="./css/common.css"></style>
<script>
    import Sidebar from "../layout/Sidebar.vue";
    import {authHeader} from "../../auth";

    export default {
        name: "PurchaseOrderPaid",
        components: {
            Sidebar
        },
        data() {
            return {
                paidOrderData: [],
                message: "",
                statusMessage: "No Record Found"
            }
        },
        created() {
            document.title = 'Geek Buy Back - All Paid Order';
            this.getPurchasePaidOrderData();   
        },
        methods:{
            getPurchasePaidOrderData: function() {
                var config = {
                    method: "GET",
                    url: this.$api + this.$config.dashboard.purchaseOrderPaidURL,
                    headers: authHeader()
                };
                this.$axios(config).then(response => {
                    if(response.data.status == "success") {
                        this.paidOrderData = response.data.data;
                        if(this.paidOrderData.length == 0)
                        {
                            this.message = this.statusMessage;
                        }
                    }
                }).catch(error => {
                    console.log(error);
                });   
            },
            viewPurchaseInvoice: function(invoiceID) {
                this.$router.push({
                    name: 'user-purchase-order-detail', 
                    params: { 
                        invoiceID: invoiceID 
                    }
                });
            },
        }
    }
</script>
